import createFetchClient, { type Client, type ClientOptions } from 'openapi-fetch'
import type { paths } from '../../types.agent.d.ts'
export type {
    Client as OpenApiClient,
    ClientPathsWithMethod as OpenApiClientPathsWithMethod,
    MaybeOptionalInit as OpenApiMaybeOptionalInit,
    MethodResponse as OpenApiMethodResponse,
} from 'openapi-fetch'

export type NetdataAgentClient = Client<paths>

/**
 * Creates a typed fetch client for the Netdata Agent API.
 * Quick start:
 *   const agent = createAgentClient({ baseUrl: "http://localhost:19999" });
 *   const response = await agent.GET("/api/v3/nodes");
 */
export default function createAgentClient(options: ClientOptions = {}): NetdataAgentClient {
    return createFetchClient<paths>(options)
}
